




























import { Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  @Prop() pluginAppid!: string;

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要更新该插件吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("oplatformapps/plugin", {
              appid: this.appid,
              action: "update",
              plugin_appid: fieldValues.plugin_appid,
              user_version: fieldValues.user_version
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
